export default "  <div class=\"av-backdrop\" [class.av-backdrop--active]=\"active\" (click)=\"backdropClick.emit()\"></div>\r\n";